import React, {Component} from "react";
import {Card, CardBody, Row} from "reactstrap";

import Hr from "../../components/hr/hr"
import PositionIcon from "../../components/position-icon/position-icon";

class PlayerFavoritePositionCard extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const {favorite_position_data} = this.props;
        const favoritePosition = favorite_position_data;


        return <div className="mp-0">
            <Card className="mx-1 mb-2 shadow player-dashboard-card-height">
                <CardBody className="mx-1 p-1">
                    <Row className="mp-0">
                        <h6>Most Common Position <Hr/></h6>
                    </Row>
                    {favoritePosition &&
                    <div className="mt-2">
                        <PositionIcon position={favoritePosition}/>
                        <p className="mt-1 small secondary-color">{favoritePosition.name}</p>
                    </div>
                    }
                    {!favoritePosition &&
                    <h6 className="text-secondary">No Activities Played</h6>
                    }
                </CardBody>
            </Card>
        </div>
    };
}

export const findFavoritePosition = (activities, positions) => {
    if (!activities || activities.length === 0 || !positions || positions.length === 0) {
        return null
    }

    const positionCounts = [];
    positions.forEach(position => {
        positionCounts[position.id] = {position: position.id, count: 0}
    });


    const activityPositionCounts = activities.map(activity => {
        return {position: activity.position, count: activity.results.length}
    });
    activityPositionCounts.forEach(positionCount => {
        positionCounts[positionCount.position].count += positionCount.count
    });

    const favoritePosition = positionCounts && positionCounts.length > 0 && positionCounts
        .reduce((total, position) => {
            return total.count > position.count ? total : position
        }, {count: 0});

    return positions.find(position => position.id === favoritePosition.position)
};

export default PlayerFavoritePositionCard;



// WEBPACK FOOTER //
// ./src/components/components/player-favorite-position-card/player-favorite-position-card.js